import { PhoneFormInput, TCountry } from '@unified-checkout/kit-components';
import { FieldErrors, UseFormRegister, UseFormSetValue } from 'react-hook-form';
import { Dispatch, SetStateAction } from 'react';
import parseMax from 'libphonenumber-js/mobile';
import { useTranslation } from 'react-i18next';

type TFieldValues = { phone_number: string } & any;

type OneClickPhoneInputProps = {
  register: UseFormRegister<TFieldValues>;
  clearErrors: () => void;
  setValue: UseFormSetValue<TFieldValues>;
  errors: FieldErrors<TFieldValues>;
  country: TCountry;
  setCountry: Dispatch<SetStateAction<TCountry>>;
  disableDropdown?: boolean;
};

export const OneClickPhoneInput = ({
  register,
  clearErrors,
  setValue,
  errors,
  country,
  setCountry,
  disableDropdown
}: OneClickPhoneInputProps) => {
  const { t } = useTranslation('kitComponents');

  const phoneRegistration = () =>
    register('phone_number', {
      onChange: (e) => {
        clearErrors();
        const phoneNumber = e.target.value;
        const trimmedNumber = phoneNumber.replace(/\D/g, '');
        setValue('phone_number', trimmedNumber);
      },
      validate: (value) => {
        if (!value) return 'Phone number is required';
        return (
          parseMax(country.code + value)?.isValid() || t('PHONE_NOT_VALID')
        );
      },
    });
    
  return (
    <>
      <PhoneFormInput
        name="phone_number"
        phoneFormRegister={phoneRegistration()}
        selectedCountry={country}
        setSelectedCountry={setCountry}
        placeholder="10 000 0000"
        error={errors.phone_number}
        autoFocus
        customStyle={{
          borderColor: errors.phone_number ? '#ff7397' : '#D0D5DD',
        }}
        disableDropdown={disableDropdown}
      />
      {errors.phone_number && (
        <p className="mt-1 text-sm text-red-500">
          {errors.phone_number.message}
        </p>
      )}
    </>
  );
};
